import React from "react";

function TimeConflicts(props) {
    const events = props.events;

    function compare(eventA, eventB) {
        if (eventA.time == eventB.time && eventA.date == eventB.date) {
            return true;
        } else {
            return false;
        }
    }

    function groupDuplicates(array, compare) {
        return array.reduce((acc, item) => {
            const existingGroup = acc.find(g => (compare(g[0], item)));
            if (existingGroup) {
                existingGroup.push(item);
            } else {
                acc.push([item])
            }
            return acc;
        }, []);
    }

    const duplicates = groupDuplicates(events, compare).filter(i => (i.length > 1));
    var dupTime, dupDate;
    
    if (duplicates.length != 0) {
        return (
            <div>
                <p className="text-black text-[24px] font-semibold ml-[0%] pb-[0px]">Time Conflicts</p>
                <ul style={{listStyleType: 'disc', paddingLeft: '3%'}}>
                    {duplicates.map((list) => {
                        return <li>
                            {list.map((event) => {
                                dupTime = event.time;
                                dupDate = event.date;
                                return event.eventName + ", "
                            })}
                            occur at {dupTime} on {dupDate}!
                        </li>
                    })}
                </ul>
            </div>
        );    
    } else {
        return (
            <div>
                <p className="text-black text-[24px] font-semibold ml-[0%] pb-[0px]">Time Conflicts</p>
                <p className="text-black text-[16px] font-text ml-[0%] pb-[0px]">No time conflicts!</p>
            </div>
        )
    }
}

export default TimeConflicts;